(ns manage.campaign-insights-page.db
  (:require ["moment/min/moment-with-locales$default" :as moment]
            [clojure.string :as str]
            [common.form.core :as form]
            [common.widgets.daterange-picker :refer [shortcuts-items]]
            [mate.core :as mc]
            [re-frame.core :as rf]))

(def initial-value
  {:adset-ids []
   :aggregate-by :day
   :channel ""
   :date-range ((:getValue (some #(when (= "last_30_days" (:id %)) %) (shortcuts-items))))})

(form/register-form {:namespace :form.campaign-insights
                     :initial-value initial-value})

(def use-bind-control (partial form/use-bind-control :form.campaign-insights))

(def aggregrate-options
  [{:label "Day"
    :value :day}
   {:label "Week"
    :value :week}
   {:label "Month"
    :value :month}
   {:label "Quarter"
    :value :quarter}])

(defmulti parse-date (fn [time-unit _date-str]
                       time-unit))

(defmethod parse-date :week [_time-unit date-str]
  ;; m is cloned, as the `(.weekday ...)` call mutates m.
  ;; .weekday is used to make sure we take the year in which the week started in.
  ;;
  ;; nl locale is used for weeks, as it uses monday as the start of the week.
  (let [m (-> (moment date-str)
              (.weekday 0)
              (.locale "nl"))]
    {:value [(.year m) (.week m)]
     :label (.format m "ww, YYYY")}))

(defmethod parse-date :month [_time-unit date-str]
  (let [m (moment date-str)]
    {:value [(.year m) (.month m)]
     :label (.format m "MMM, YYYY")}))

(defmethod parse-date :quarter [_time-unit date-str]
  (let [m (moment date-str)]
    {:value [(.year m) (.quarter m)]
     :label (str "Q" (.format m "Q, YYYY"))}))

(defmethod parse-date :day [_time-unit date-str]
  (let [m (moment date-str)]
    {:value [(.year m) date-str]
     :label (.format m "LL")}))

(defmethod parse-date :default [_time-unit date-str]
  (let [m (moment date-str)]
    {:value [(.year m) date-str]
     :label (.format m "LL")}))

(defn aggregrate-by [time-unit ks records]
  (->> records
       (mc/group-by (fn [record]
                      (parse-date time-unit (:day record))) ; group-by's key function
                    (fn [record]
                      (select-keys record ks))              ; group-by's value function
                    (partial merge-with +)                  ; reducing function on the values assigned to the same key
                    nil)                                    ; initial value for the reducing function
       (map (fn [[time data]]
              (merge {time-unit (:value time)
                      :label (:label time)}
                     data)))))

(rf/reg-sub :page.campaign-insights/impressions-clicks
  :<- [:resource.campaign-insights/impressions-clicks]
  :<- [:form.campaign-insights/value [:aggregate-by]]
  (fn [[impressions-clicks aggregrate-unit]]
    (->> impressions-clicks
         (aggregrate-by aggregrate-unit [:impressions :clicks])
         (map (fn [{:keys [impressions clicks] :as item}]
                (assoc item :ctr (when (pos? impressions)
                                   (/ clicks impressions)))))
         (sort-by aggregrate-unit))))

(rf/reg-sub :page.campaign-insights/video-quartiles
  :<- [:resource.campaign-insights/video-quartiles]
  :<- [:form.campaign-insights/value [:aggregate-by]]
  (fn [[video-quartiles aggregrate-unit]]
    (->> video-quartiles
         (aggregrate-by (or aggregrate-unit :day) [:start :first_quartile :midpoint :third_quartile :complete])
         (sort-by (or aggregrate-unit :day)))))

(rf/reg-sub :page.campaign-insights/variant-average-impressions
  :<- [:resource.campaign-insights/variant-average-impressions]
  (fn [{:keys [share_of_total variants]}]
    {:share-of-total share_of_total
     :variants (sort-by :impressions > variants)}))

(rf/reg-sub :page.campaign-insights/variant-average-clicks
  :<- [:resource.campaign-insights/variant-average-clicks]
  (fn [{:keys [share_of_total variants]}]
    {:share-of-total share_of_total
     :variants (sort-by :clicks > variants)}))

(rf/reg-sub :page.campaign-insights/variant-average-ctr
  :<- [:resource.campaign-insights/variant-average-ctr]
  (fn [{:keys [share_of_total variants]}]
    {:share-of-total share_of_total
     :variants (sort-by :ctr > variants)}))

(rf/reg-event-fx :page.campaign-insights/get-graph-data
  [(rf/inject-cofx :sub [:form.campaign-insights/value []])]
  (fn [{:form.campaign-insights/keys [value]} _]
    (let [[start-date end-date] (map #(.format % "YYYY-MM-DD") (:date-range value))
          params (merge {:start_date start-date
                         :end_date end-date}
                        (when-let [adset-ids (seq (:adset-ids value))]
                          {:adset_ids (str/join "," adset-ids)}))]
      {:fx [[:dispatch [:resource.campaign-insights/get-graph-data params]]]})))

(rf/reg-event-fx :page.campaign-insights/save-order
  (fn [_ [_ charts]]
    {:fx [[:localstorage/save [:campaign-insights-order (mapv :id charts)]]]}))
